import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { PortalLanguageTranslation } from "../../../../../services/api/types/portalConfiguration/translations";
import { useLanguages } from "../../../../../context/LanguagesContext";
import { brand, gray } from "../../../../../theme/themePrimitives";

interface ReplaceModalProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  word: PortalLanguageTranslation;
  changeTranslation: () => void;
  handleSelectedWordChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

export const ReplaceModal: React.FC<ReplaceModalProps> = ({
  openModal,
  setOpenModal,
  word,
  changeTranslation,
  handleSelectedWordChange,
}) => {
  const { getLanguageDetails } = useLanguages();

  return (
    <Modal open={openModal} onClose={() => setOpenModal(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: "90vh",
          overflowY: "auto",
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.24)",
          padding: "16px",
          width: "50%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Change translation</Typography>
          <IconButton
            sx={{
              border: "none",
            }}
            onClick={() => setOpenModal(false)}
          >
            <CloseIcon sx={{ color: "#98A2B3" }} />
          </IconButton>
        </Box>
        <Stack spacing={2} sx={{ marginTop: "1rem" }}>
          <Stack spacing={1}>
            <Typography variant="subtitle2">
              {getLanguageDetails(word.languageCode)?.name} language
            </Typography>
            <TextField
              fullWidth
              id=""
              type="text"
              value={word.translation}
              variant="outlined"
              size="small"
              onChange={handleSelectedWordChange}
              slotProps={{
                input: {
                  startAdornment: (
                    <img
                      src={getLanguageDetails(word.languageCode)?.flag}
                      alt={word.languageCode}
                      width={24}
                      height={24}
                      style={{
                        border: `1px solid ${gray[300]}`,
                        borderRadius: "50%",
                        objectFit: "cover",
                        marginRight: "8px",
                      }}
                    />
                  ),
                },
              }}
            />
          </Stack>

          <Divider />

          <Button
            onClick={changeTranslation}
            fullWidth
            sx={{
              borderRadius: "12px",
              backgroundColor: `${brand[600]} !important`,
              color: `white`,
            }}
          >
            <Typography>Update</Typography>
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
